<template>
  <v-card class="ma-3">
    <v-card-title>
      <h2>{{ $t('Obligaciones fiscales') }} {{ this.selectedYear }}</h2>
    </v-card-title>
    <v-card-title>
      <v-layout align-center justify-end row fill-height wrap slot="extension" class="white--text">
        <div class="ml-3">
          <v-select
            solo
            color="primary"
            v-model="selectedYear"
            item-text="text"
            item-value="value"
            :items="years"
            row
          ></v-select>
        </div>
      </v-layout>
    </v-card-title>
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="items"
      :rows-per-page-items="[-1]"
      :total-items="items.length"
    >
      <template v-slot:headers="props">
        <tr>
          <th v-for="header in props.headers" :key="header.text" class="text-xs-center">
            {{ header.text }}
          </th>
        </tr>
      </template>
      <template v-slot:items="props">
        <tr>
          <td class="text-xs-center">{{ props.item.mod }}</td>
          <td class="text-xs-center">{{ props.item.type }}</td>
          <td
            class="text-xs-center"
            :class="props.item.months.ENE === 'S' ? 'bg-lightgreen' : 'bg-lightgray'"
          ></td>
          <td
            class="text-xs-center"
            :class="props.item.months.FEB === 'S' ? 'bg-lightgreen' : 'bg-lightgray'"
          ></td>
          <td
            class="text-xs-center"
            :class="props.item.months.MAR === 'S' ? 'bg-lightgreen' : 'bg-lightgray'"
          ></td>
          <td
            class="text-xs-center"
            :class="props.item.months.ABR === 'S' ? 'bg-lightgreen' : 'bg-lightgray'"
          ></td>
          <td
            class="text-xs-center"
            :class="props.item.months.MAY === 'S' ? 'bg-lightgreen' : 'bg-lightgray'"
          ></td>
          <td
            class="text-xs-center"
            :class="props.item.months.JUN === 'S' ? 'bg-lightgreen' : 'bg-lightgray'"
          ></td>
          <td
            class="text-xs-center"
            :class="props.item.months.JUL === 'S' ? 'bg-lightgreen' : 'bg-lightgray'"
          ></td>
          <td
            class="text-xs-center"
            :class="props.item.months.AGO === 'S' ? 'bg-lightgreen' : 'bg-lightgray'"
          ></td>
          <td
            class="text-xs-center"
            :class="props.item.months.SEP === 'S' ? 'bg-lightgreen' : 'bg-lightgray'"
          ></td>
          <td
            class="text-xs-center"
            :class="props.item.months.OCT === 'S' ? 'bg-lightgreen' : 'bg-lightgray'"
          ></td>
          <td
            class="text-xs-center"
            :class="props.item.months.NOV === 'S' ? 'bg-lightgreen' : 'bg-lightgray'"
          ></td>
          <td
            class="text-xs-center"
            :class="props.item.months.DIC === 'S' ? 'bg-lightgreen' : 'bg-lightgray'"
          ></td>
        </tr>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import apiCtrl from '@/services/api/abstract/abstract-api.js';

export default {
  name: 'FiscalObligationTable',
  components: {},
  props: ['clavedat'],
  data() {
    return {
      loading: false,
      headers: [
        {
          text: 'Mod.',
          align: 'left',
          value: 'mod',
        },
        { text: 'Tipo', value: 'type' },
        { text: 'Ene.', value: 'ENE' },
        { text: 'Feb.', value: 'FEB' },
        { text: 'Mar.', value: 'MAR' },
        { text: 'Abr.', value: 'ABR' },
        { text: 'May.', value: 'MAY' },
        { text: 'Jun.', value: 'JUN' },
        { text: 'Jul.', value: 'JUL' },
        { text: 'Ago.', value: 'AGO' },
        { text: 'Sep.', value: 'SEP' },
        { text: 'Oct.', value: 'OCT' },
        { text: 'Nov.', value: 'NOV' },
        { text: 'Dic.', value: 'DIC' },
      ],
      items: [],
      selectedYear: new Date().getFullYear(),
      years: [
        { text: '2024', value: 2024 },
        { text: '2023', value: 2023 },
        { text: '2022', value: 2022 },
        { text: '2021', value: 2021 },
        { text: '2020', value: 2020 },
        { text: '2019', value: 2019 },
        { text: '2018', value: 2018 },
        { text: '2017', value: 2017 },
        { text: '2016', value: 2016 },
        { text: '2015', value: 2015 },
        { text: '2014', value: 2014 },
      ],
    };
  },
  mounted() {
    this.getFiscalObligationData();
  },
  computed: {},
  methods: {
    getFiscalObligationData() {
      this.loading = true;
      apiCtrl
        .get('/admin/aplifisa/obligation/list/' + this.clavedat + '/year/' + this.selectedYear, {})
        .then(res => {
          this.items = res.data.data
            ? res.data.data.obligations.filter(obligation => obligation.required === true)
            : [];
          this.loading = false;
        })
        .catch(() => (this.loading = false));
    },
  },
  watch: {
    selectedYear: function() {
      this.getFiscalObligationData();
    },
  },
};
</script>

<style scoped>
.bg-lightgray {
  background-color: lightgray;
}
.bg-lightgreen {
  background-color: #00afa8;
}
</style>
